module.exports = __webpack_public_path__ + "img/drive-vil-7.b3a9bba0.svg";